module.exports = __webpack_public_path__ + "static/media/logo_200.706b339d.png";